import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import { TitleContext } from '@providers/TitleProvider'
import TitleService from '@services/TitleService'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'
import GoogleTagManager from '@utils/gtm/google-tag-manager'

interface Props {
  onClick: () => void
}

const AddToMenu: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { title, updateTitle } = useContext(TitleContext)
  const session = useSession()

  const favoriteClick = async (): Promise<void> => {
    onClick()

    const mod = title.favorited ? -1 : 1
    const favorites = Math.max((title.favorites || 0) + mod, 0)
    if (await TitleService.toggleFavorite(title)) {
      const newFavorited = !title.favorited
      GoogleTagManager.trackEvent(newFavorited ? 'title_favorite' : 'title_unfavorite', {
        content_title: {
          id: title.uuid,
        },
        favorite_context: 'add_to_menu',
      })
      updateTitle({ favorited: newFavorited, favorites })
    }
  }

  const addToCollectionClick = (): void => {
    onClick()

    if (session.hasPremiumFeatures()) {
      openDialog('add_to_collection')
    } else {
      openDialog('require_premium_collections')
    }
  }

  return (
    <div className="text-sm p-1.5">
      <button type="button" className="block cursor-pointer mb-2" onClick={favoriteClick}>
        {t(title.favorited ? 'action.removeFromFavorites' : 'action.addToFavorites')}
      </button>
      <button type="button" className="block cursor-pointer" onClick={addToCollectionClick}>
        {t('action.addToCollection')}
      </button>
    </div>
  )
}

export default AddToMenu
